import React from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import "../../App.css";
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa'
import { Link } from "react-router-dom";
const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h3
              className="mt-0 mb-16 text-ubuntu-bold reveal-from-bottom"
              data-reveal-delay="200"
            >
              Welcome to my
              <br />
              <span className="text-color-primary"> personal page</span>
            </h3>
          </div>
          <div
            className="hero-figure reveal-from-bottom illustration-element-01"
            data-reveal-value="10px"
            data-reveal-delay="200"
          >
            <div className="container-wrp">
              <div className="container-content-l">
                <h3 className="mt-0 reveal-from-bottom text-ubuntu-bold" data-reveal-delay="200">
                  &lt;Adler <span className="text-color-primary">Kesley</span>{" "}
                  /&gt;
                </h3>
                <div
                  className="text-fira-bold flex-start fs-14 reveal-from-bottom"
                  data-reveal-delay="200"
                >
                  <span role="img" aria-label="emojiWork">
                    🧑‍💼{" "}
                  </span>{" "}
                  Developer at Superlógica Tecnologias
                  <br />
                  <span role="img" aria-label="emojiWork">
                    📚{" "}
                  </span>{" "}
                  Always improving
                  <br />
                  <span role="img" aria-label="emojiWork">
                    🌎{" "}
                  </span>{" "}
                  Sergipe - Brazil
                  <br />
                  Currently working with React Native. Take a look at the{" "}
                  <Link to="/skills">
                    <span className="text-nice">Skills</span>
                  </Link>{" "}
                  section
                  <br />
                  <br />
                  <span className="text-color-secondary"><span role='img' aria-label='emoj'>👋 </span> Get in touch !</span>
                  <br />
                  <div className='row'>
                  <a className='opa' href="https://github.com/adlerke" target='blank'><FaGithub size={30} color='rgb(113, 71, 212)'/> </a> &nbsp;
                  <a className='opa' href="https://www.instagram.com/_adlerk/" target='blank'><FaInstagram size={30} color='rgb(113, 71, 212)'/> </a>&nbsp;
                  <a className='opa' href="https://www.linkedin.com/in/adler-kesley-34b09511b/" target='blank'><FaLinkedin size={30} color='rgb(113, 71, 212)'/> </a>
                  </div>
                </div>
              </div>
              <div className="container-content-r">
                <img
                className='cover-img'
                  src={require("./../../assets/images/profilePic.jpg")}
                  alt="My"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
